'use strict';

var NtryDataCfest = {};

NtryDataCfest.config = {
    1: {
        "gridSize": {
            width: 7,
            height: 5
        },
        "tileSize": 68,
        "bitmapPath": "/img/assets/ntry/bitmap/maze2/",
        "limitBlockCnt": 4,
        "availableBlocks": [
            "maze_step_move_step"
        ],
        "hints": [
            {
                "title": Lang.Menus.maze_1_title,
                "content": Lang.Menus.maze_1_content,
                "detail": Lang.Menus.maze_1_detail,
                "image": 1
            }
        ],
        "intro": {
            "content": Lang.Menus.maze_1_intro
        },
        "theme": "mazeVer2"
    },
    2: {
        "gridSize": {
            width: 7,
            height: 5
        },
        "tileSize": 68,
        "bitmapPath": "/img/assets/ntry/bitmap/maze2/",
        "limitBlockCnt": 6,
        "availableBlocks": [
            "maze_step_move_step",
            "maze_step_rotate",
            "maze_step_jump"
        ],
        "hints": [
            {
                "title": Lang.Menus.maze_2_title_1,
                "content": Lang.Menus.maze_2_content_1,
                "detail": Lang.Menus.maze_2_detail_1,
                "image": 2
            },
            {
                "title": Lang.Menus.maze_2_title_2,
                "content": Lang.Menus.maze_2_content_2,
                "detail": Lang.Menus.maze_2_detail_2,
                "image": 1
            }
        ],
        "intro": {
            "content": Lang.Menus.maze_2_intro
        },
        "theme": "mazeVer2"
    },
    3: {
        "gridSize": {
            width: 7,
            height: 5
        },
        "tileSize": 68,
        "bitmapPath": "/img/assets/ntry/bitmap/maze2/",
        "limitBlockCnt": 3,
        "availableBlocks": [
            "maze_step_move_step",
            "maze_step_rotate",
            "maze_step_for"
        ],
        "essentialBlockInfo": {
            matchCnt: 1,
            blocks: [
                "maze_step_for",
                "maze_step_unfor"
            ]
        },
        "hints": [
            {
                "title": Lang.Menus.maze_3_title,
                "content": Lang.Menus.maze_3_content,
                "detail": Lang.Menus.maze_3_detail,
                "image": 3
            }
        ],
        "intro": {
            "content": Lang.Menus.maze_3_intro
        },
        "theme": "mazeVer2"
    },
    4: {
        "gridSize": {
            width: 7,
            height: 6
        },
        "tileSize": 68,
        "bitmapPath": "/img/assets/ntry/bitmap/maze2/",
        "limitBlockCnt": 5,
        "availableBlocks": [
            "maze_step_move_step",
            "maze_step_rotate",
            "maze_step_jump",
            "maze_step_for"
        ],
        "essentialBlockInfo": {
            matchCnt: 1,
            blocks: [
                "maze_step_for",
                "maze_step_unfor"
            ]
        },
        "hints": [
            {
                "title": Lang.Menus.maze_4_title,
                "content": Lang.Menus.maze_4_content,
                "detail": Lang.Menus.maze_4_detail,
                "image": 3
            }
        ],
        "intro": {
            "content": Lang.Menus.maze_4_intro
        },
        "theme": "mazeVer2"
    },
    5: {
        "gridSize": {
            width: 7,
            height: 5
        },
        "tileSize": 68,
        "bitmapPath": "/img/assets/ntry/bitmap/maze2/",
        "limitBlockCnt": 5,
        "availableBlocks": [
            "maze_step_move_step",
            "maze_step_rotate",
            "maze_step_for_true_1",
            "maze_step_if_1"
        ],
        "essentialBlockInfo": {
            matchCnt: 2,
            blocks: [
                "maze_step_for_true",
                "maze_step_if",
                "maze_step_unfor_true",
                "maze_step_unif"
            ]
        },
        "hints": [
            {
                "title": Lang.Menus.maze_5_title_1,
                "content": Lang.Menus.maze_5_content_1,
                "detail": Lang.Menus.maze_5_detail_1,
                "image": 5
            },
            {
                "title": Lang.Menus.maze_5_title_2,
                "content": Lang.Menus.maze_5_content_2,
                "detail": Lang.Menus.maze_5_detail_2,
                "image": 4
            }
        ],
        "intro": {
            "content": Lang.Menus.maze_5_intro
        },
        "theme": "mazeVer2"
    },
    6: {
        "gridSize": {
            width: 7,
            height: 6
        },
        "tileSize": 68,
        "bitmapPath": "/img/assets/ntry/bitmap/maze2/",
        "limitBlockCnt": 5,
        "availableBlocks": [
            "maze_step_move_step",
            "maze_step_rotate",
            "maze_step_for_true_1",
            "maze_step_if_1"
        ],
        "essentialBlockInfo": {
            matchCnt: 2,
            blocks: [
                "maze_step_for_true",
                "maze_step_if",
                "maze_step_unfor_true",
                "maze_step_unif"
            ]
        },
        "hints": [
            {
                "title": Lang.Menus.maze_6_title_1,
                "content": Lang.Menus.maze_6_content_1,
                "detail": Lang.Menus.maze_6_detail_1,
                "image": 5
            },
            {
                "title": Lang.Menus.maze_6_title_2,
                "content": Lang.Menus.maze_6_content_2,
                "detail": Lang.Menus.maze_6_detail_2,
                "image": 4
            }
        ],
        "intro": {
            "content": Lang.Menus.maze_6_intro
        },
        "theme": "mazeVer2"
    }
}

/*
 * Generate tile entities. wall and road only.
 */
NtryDataCfest.tileMap = {
    1: [
        ["wall_08","wall_08","wall_08","wall_08","wall_08","wall_08","wall_08"],
        ["wall_08","wall_08","wall_08","wall_08","wall_08","wall_08","wall_08"],
        ["wall_08","wall_08","wall_08","road_09","road_09","road_09","road_09"],
        ["wall_08","wall_08","wall_08","wall_08","wall_08","wall_08","wall_08"],
        ["wall_08","wall_08","wall_08","wall_08","wall_08","wall_08","wall_08"]
    ],
    2: [
        ["wall_08","wall_08","wall_08","wall_08","wall_08","wall_08","wall_08"],
        ["wall_08","wall_08","wall_08","wall_08","wall_08","wall_08","wall_08"],
        ["wall_08","wall_08","road_05","road_09","road_06","wall_08","wall_08"],
        ["wall_08","wall_08","road_10","wall_04","road_10","wall_08","wall_08"],
        ["wall_08","wall_08","wall_02","wall_01","wall_03","wall_08","wall_08"]
    ],
    3: [
        ["wall_08","wall_08","wall_08","wall_08","wall_08","wall_08","wall_08"],
        ["wall_08","wall_08","wall_08","wall_08","wall_08","wall_08","wall_08"],
        ["wall_01","road_09","road_09","road_09","road_09","road_09","road_09"],
        ["wall_08","wall_08","wall_08","wall_08","wall_08","wall_08","wall_08"],
        ["wall_08","wall_08","wall_08","wall_08","wall_08","wall_08","wall_08"]
    ],
    4: [
        ["wall_08","wall_08","wall_07","wall_01","wall_01","wall_02","wall_08"],
        ["road_09","road_09","road_09","road_09","road_06","wall_03","wall_08"],
        ["wall_02","wall_08","wall_07","wall_04","road_10","wall_06","wall_08"],
        ["wall_08","wall_04","wall_07","wall_01","road_10","wall_06","wall_08"],
        ["wall_08","wall_07","wall_02","wall_03","road_10","wall_06","wall_09"],
        ["road_09","road_09","road_09","road_09","road_08","wall_06","wall_06"]
    ],
    5: [
        ["wall_08","wall_07","wall_08","wall_08","wall_07","wall_08","wall_08"],
        ["wall_08","road_05","road_11","road_11","road_11","road_06","wall_08"],
        ["wall_08","road_12","wall_08","wall_08","wall_07","road_12","wall_08"],
        ["wall_08","road_12","wall_08","wall_08","wall_07","road_12","wall_08"],
        ["wall_08","road_12","wall_08","road_09","road_09","road_08","wall_08"]
    ],
    6: [
        ["wall_06","wall_06","wall_08","wall_06","wall_06","wall_08","wall_06"],
        ["wall_06","road_05","road_09","road_09","road_09","road_06","wall_06"],
        ["wall_06","road_12","wall_08","wall_06","wall_06","road_10","wall_06"],
        ["wall_06","road_12","wall_08","wall_06","wall_06","road_10","wall_06"],
        ["wall_06","road_07","road_09","road_09","wall_06","road_10","wall_06"],
        ["wall_06","wall_06","wall_08","wall_06","wall_06","road_10","wall_06"]
    ]
};

NtryDataCfest.fence_behind = {
    1: [
        {image: "handrail_02", x: 3, y: 1},
        {image: "handrail_02", x: 4, y: 1},
        {image: "handrail_02", x: 5, y: 1},
        {image: "handrail_02", x: 6, y: 1}
    ]
}

NtryDataCfest.fence_front = {
    1: [
        {image: "handrail_02", x: 3, y: 2},
        {image: "handrail_02", x: 4, y: 2},
        {image: "handrail_02", x: 5, y: 2},
        {image: "handrail_02", x: 6, y: 2}
    ],
    2: [
        {image: "handrail_02", x:3, y:2},
        {image: "handrail_11", x:2, y:3},
        {image: "handrail_12", x:4, y:3},
        {image: "handrail_13", x:2, y:2},
        {image: "handrail_14", x:4, y:2}

    ]
}

NtryDataCfest.obstacle = {
    2: [
        {image: "obstacle_01", x:3, y:2, type: Ntry.STATIC.OBSTACLE_BEE}
    ],
    4: [
        {image: 'obstacle_01', x:1, y:1, type: Ntry.STATIC.OBSTACLE_BEE},
        {image: 'obstacle_01', x:3, y:1, type: Ntry.STATIC.OBSTACLE_BEE},
        {image: 'obstacle_01', x:4, y:2, type: Ntry.STATIC.OBSTACLE_BEE},
        {image: 'obstacle_01', x:4, y:4, type: Ntry.STATIC.OBSTACLE_BEE},
        {image: 'obstacle_01', x:1, y:5, type: Ntry.STATIC.OBSTACLE_BEE},
        {image: 'obstacle_01', x:3, y:5, type: Ntry.STATIC.OBSTACLE_BEE}
    ]
};

NtryDataCfest.player = {
    1: {
        x: 3,
        y: 2,
        script: '<xml><block type="maze_step_unstart" class="inline maze_step_unstart" id="32" x="20" y="22" movable="false" deletable="false"><next><block type="maze_step_move_unstep" class="inline maze_step_move_unstep" id="36" deletable="false"><next><block type="maze_step_move_unstep" class="inline maze_step_move_unstep" id="38" deletable="false"></block></next></block></next></block></xml>'
    },
    2: {
        x: 2,
        y: 3,
        direction: Ntry.STATIC.NORTH,
        script: '<xml><block type="maze_step_unstart" class="inline maze_step_unstart" id="31" x="20" y="22" movable="false" deletable="false"></block></xml>'
    },
    3: {
        x: 1,
        y: 2,
        script: '<xml><block type="maze_step_unstart" class="inline maze_step_unstart" id="31" x="20" y="22" movable="false" deletable="false"><next><block type="maze_step_unfor" class="inline maze_step_unfor" id="34" inline="true" deletable="false"><field name="VALUE">1</field><statement name="DO"><block type="maze_step_move_unstep" class="inline maze_step_move_unstep" id="37" deletable="false"></block></statement></block></next></block></xml>'
    },
    4: {
        x: 0,
        y: 1,
        script: '<xml><block type="maze_step_unstart" class="inline maze_step_unstart" id="31" x="20" y="22" movable="false" deletable="false"></block></xml>'
    },
    5: {
        x: 1,
        y: 4,
        direction: Ntry.STATIC.NORTH,
        script: '<xml><block type="maze_step_unstart" class="inline maze_step_unstart" id="20" deletable="false" movable="false" x="20" y="22"><next><block type="maze_step_unfor_true_1" class="inline maze_step_unfor_true_1" id="21" deletable="false"><statement name="STACK"><block type="maze_step_move_unstep" class="inline maze_step_move_unstep" id="24" deletable="false"><next><block type="maze_step_unif_1" class="inline maze_step_unif_1" id="22" deletable="false"></block></next></block></statement></block></next></block></xml>'
    },
    6: {
        x: 5,
        y: 5,
        direction: Ntry.STATIC.NORTH,
        script: '<xml><block type="maze_step_unstart" class="inline maze_step_unstart" id="17" x="20" y="22" movable="false" deletable="false"></block></xml>'
    }
};

NtryDataCfest.goal = {
    1: [
        {image: "goal_1", x:6, y:2}
    ],
    2: [
        {image: "goal_1", x:4, y:3}
    ],
    3: [
        {image: "goal_1", x:6, y:2}
    ],
    4: [
        {image: "goal_1", x:0, y:5}
    ],
    5: [
        {image: "goal_1", x:3, y:4}
    ],
    6: [
        {image: "goal_1", x:3, y:4}
    ]
};

NtryDataCfest.space_map = {
};

NtryDataCfest.help = {
};


NtryDataCfest.FRAMES = {};
NtryDataCfest.FRAMES[Ntry.STATIC.STAND] = {
    north: {key: 2, frame: [0]},
    east:  {key: 1, frame: [0]},
    south: {key: 0, frame: [0]},
    west:  {key: 1, frame: [0], flip: true},
    next: Ntry.STATIC.STAND,
    movement: 0
};
NtryDataCfest.FRAMES[Ntry.STATIC.WALK] = {
    north: {key: 2, frame: _.range(0, 15)},
    east:  {key: 1, frame: _.range(0, 16)},
    south: {key: 0, frame: _.range(0, 15)},
    west:  {key: 1, frame: _.range(0, 16), flip: true},
    next: Ntry.STATIC.STAND,
    movement: 1,
    gridMovement: 1
};
NtryDataCfest.FRAMES[Ntry.STATIC.JUMP] = {
    north: {key: 14, frame: _.range(0, 11)},
    east:  {key: 12, frame: _.range(0, 14)},
    south: {key: 13, frame: _.range(0, 11)},
    west:  {key: 12, frame: _.range(0, 14), flip: true},
    next: Ntry.STATIC.STAND,
    movement: 2,
    gridMovement: 2
};
NtryDataCfest.FRAMES[Ntry.STATIC.TURN_RIGHT] = {
    north: {key: 15, frame: [4, 3, 2]},
    east:  {key: 15, frame: [2, 1, 0]},
    south: {key: 15, frame: [8, 7, 6]},
    west:  {key: 15, frame: [6, 5, 4]},
    next: Ntry.STATIC.STAND,
    rotation: 1,
    movement: 0
};
NtryDataCfest.FRAMES[Ntry.STATIC.TURN_LEFT] = {
    north: {key: 15, frame: [4, 5, 6]},
    east:  {key: 15, frame: [2, 3, 4]},
    south: {key: 15, frame: [8, 0, 1]},
    west:  {key: 15, frame: [6, 7, 8]},
    next: Ntry.STATIC.STAND,
    rotation: -1,
    movement: 0
};
var simoorookFrame = new Array(8).join('0').split('').concat(_.range(0, 7));
NtryDataCfest.FRAMES[Ntry.STATIC.SIMOOROOK] = {
    north: {key: 5, frame: simoorookFrame},
    east:  {key: 4, frame: simoorookFrame},
    south: {key: 3, frame: simoorookFrame},
    west:  {key: 4, frame: simoorookFrame, flip: true},
    next: Ntry.STATIC.FAIL,
    movement: 0
};
NtryDataCfest.FRAMES[Ntry.STATIC.WALL_CRASH] = {
    north: {key: 8, frame: _.range(0, 12)},
    east:  {key: 6, frame: _.range(0, 11)},
    south: {key: 7, frame: _.range(0, 12)},
    west:  {key: 6, frame: _.range(0, 11), flip: true},
    next: Ntry.STATIC.FAIL,
    movement: -0.3
};
NtryDataCfest.FRAMES[Ntry.STATIC.BEE_ATTACK] = {
    north: {key: 10, frame: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1]},
    east : {key: 10, frame: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1]},
    south: {key: 10, frame: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1]},
    west : {key: 10, frame: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1]},
    next: Ntry.STATIC.FAIL,
    movement: 0
};
NtryDataCfest.FRAMES[Ntry.STATIC.ELECTRIC_SHOCK] = {
    north: {key: 9, frame: [0, 1, 0, 1, 0, 1, 0, 1, 2]},
    east:  {key: 9, frame: [0, 1, 0, 1, 0, 1, 0, 1, 2]},
    south: {key: 9, frame: [0, 1, 0, 1, 0, 1, 0, 1, 2]},
    west:  {key: 9, frame: [0, 1, 0, 1, 0, 1, 0, 1, 2]},
    next: Ntry.STATIC.FAIL,
    movement: 0
};
NtryDataCfest.FRAMES[Ntry.STATIC.SLIP] = {
    north: {key: 11, frame: _.range(0, 6)},
    east:  {key: 11, frame: _.range(0, 6)},
    south: {key: 11, frame: _.range(0, 6)},
    west:  {key: 11, frame: _.range(0, 6)},
    next: Ntry.STATIC.FAIL,
    movement: 0.5
};
NtryDataCfest.FRAMES[Ntry.STATIC.STOP] = {};
